/**
 * Подпись пункта нижнего меню телефона: переносить ли её на вторую строку (28.10.2026, iOS 1.1.2, слово владельца).
 *
 * У пункта нижнего меню ширина — четверть экрана: на 390 px это 93,5 px. На iPhone 14 / iOS 16.4 «ИИ-тренажёры»
 * переносилась по дефису («ИИ-» / «тренажёры»), на 393 px — уже нет: подпись почти ровно в ширину пункта.
 * Дефис — единственное место переноса в однословной подписи, поэтому однословным (без пробела) перенос запрещён:
 * текст не сокращается, а лишние доли пикселя уходят поровну в стороны (пункт центрирует подпись).
 *
 * Подписи из нескольких слов («ЖИ жаттығулары», «Оқу бөлімі», «AI Trainers») по-прежнему могут переноситься
 * по пробелу — запрет на них растянул бы строку на соседние пункты.
 */
export function dockLabelNoWrap(label: string): boolean {
  return !/\s/.test(label.trim());
}
